/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Menu from "./menu"
import Slide from "./slide"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Menu />
      <div className="absolute-container">
        <Slide id="home" className="background-soanne background-video">
        </Slide>
        {/* <Slide id="music" className="offset-slide">
          Music
        </Slide>
        <Slide id="merch" className="offset-slide">
          Merch
        </Slide>
        <Slide id="videos" className="offset-slide">
          Videos
        </Slide>
        <Slide id="lyrics" className="offset-slide">
          Lyrics
        </Slide>
        <Slide id="about" className="offset-slide">
          About
        </Slide> */}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
